import { useEffect, useMemo, useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { fetchManufacturers } from '../api';
import { useLanguage } from '../hooks/useLanguage';

const copy = {
  RU: { kicker: 'СПРАВОЧНИК', title: 'Производители', subtitle: 'Предприятия и мастерские, представленные в архиве.', loading: 'Загрузка справочника…', error: 'Не удалось загрузить справочник.', empty: 'Производители пока не добавлены.', records: 'записей', open: 'Открыть запись' },
  EN: { kicker: 'DIRECTORY', title: 'Manufacturers', subtitle: 'Factories and workshops represented in the archive.', loading: 'Loading the directory…', error: 'Unable to load the directory.', empty: 'No manufacturers have been added.', records: 'records', open: 'Open record' },
};

export default function ManufacturerListPage() {
  const { lang } = useLanguage();
  const labels = copy[lang] || copy.RU;
  const [manufacturers, setManufacturers] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    fetchManufacturers()
      .then(({ data }) => {
        if (!active) return;
        setManufacturers(Array.isArray(data) ? data : []);
        setStatus('ready');
      })
      .catch(() => active && setStatus('error'));
    return () => { active = false; };
  }, []);

  const sorted = useMemo(() => [...manufacturers].sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), lang === 'EN' ? 'en' : 'ru')), [manufacturers, lang]);

  return (
    <main className="directory-page page-width">
      <header className="directory-header">
        <div><p className="section-kicker">{labels.kicker}</p><h1>{labels.title}</h1><p>{labels.subtitle}</p></div>
        <span>{String(sorted.length).padStart(2, '0')} {labels.records}</span>
      </header>
      {status === 'loading' && <div className="directory-state">{labels.loading}</div>}
      {status === 'error' && <div className="directory-state directory-state--error">{labels.error}</div>}
      {status === 'ready' && sorted.length === 0 && <div className="directory-state">{labels.empty}</div>}
      {status === 'ready' && sorted.length > 0 && (
        <div className="directory-list">
          {sorted.map((manufacturer, index) => (
            <Link to={'/manufacturers/' + manufacturer.id} key={manufacturer.id}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <strong>{manufacturer.name}</strong>
              <small>{labels.open}</small>
              <ArrowUpRight size={17} />
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}
